module.exports = __webpack_public_path__ + "static/media/balajirangan-1.a0a2f958.png";